module.exports = __webpack_public_path__ + "static/img/confetti.6968a55.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/confetti.svg
// module id = H4Dz
// module chunks = 48